// accepted.ts — CORE-1660
//
// Какие редакции человек принимает прямо сейчас — с учётом языка интерфейса и
// юрисдикции. Отдельно от `editions.ts`, чтобы тот оставался чистым (без i18n и
// платформы) и проверялся тестами.

import { getCurrentLanguage } from '../i18n';
import { isForeignJurisdiction, readJurisdictionSignals } from '../utils/legalJurisdiction';
import {
  currentEdition,
  languageVariant,
  registrationDocuments,
  type AcceptedDocument,
  type LegalDocumentId,
  type LegalVariant,
} from './editions';
import type { LegalOperator } from './operator';

/** Соглашение и политика в той редакции, которую показывает форма регистрации. */
export function acceptedRegistrationDocuments(): AcceptedDocument[] {
  return registrationDocuments(isForeignContour());
}

/**
 * Человек вне российского контура: ему показываются английские Условия
 * (AGAPE.IO Limited). Правило то же, что выбирает редакцию соглашения
 * (`utils/legalJurisdiction`, CORE-1555).
 */
export function isForeignContour(): boolean {
  return isForeignJurisdiction(readJurisdictionSignals(getCurrentLanguage()));
}

/** Оператор, которого называют экраны согласий: по тому же правилу, что редакция соглашения (CORE-1661). */
export function currentOperator(): LegalOperator {
  return isForeignJurisdiction(readJurisdictionSignals(getCurrentLanguage())) ? 'intl' : 'ru';
}

/** Короткий текст (cookie, реклама, запись Live-сессии) на языке интерфейса — или на явно названном. */
export function acceptedDocument(documentId: LegalDocumentId, variant?: LegalVariant): AcceptedDocument {
  return currentEdition(documentId, variant ?? languageVariant(getCurrentLanguage()));
}

/**
 * CORE-1929 — что принимает рекламная галочка: её строка на языке интерфейса и
 * полный текст согласия (`marketing-consent-full`, только русский), на который
 * строка ссылается. Так задумано в CORE-1657: запись называет оба текста.
 */
export function marketingConsentDocuments(): AcceptedDocument[] {
  return [acceptedDocument('marketing-consent'), currentEdition('marketing-consent-full', 'ru')];
}
